export enum EDiscoverPunishmentAlertType {
  Punishment = "punishment_alert",
  FinalPunishment = "final_punishment_alert",
}

export interface IDiscoverAlerts {
  [EDiscoverPunishmentAlertType.Punishment]: boolean;
  [EDiscoverPunishmentAlertType.FinalPunishment]: boolean;
}
